module.exports = __webpack_public_path__ + "static/media/curate_white.60ac7140.svg";